export default {"src":"/_next/static/image/public/images/ic_myprofile_white_vertical_menu.82d69dfd7f620e2ef8e9b371e6fb29e2.svg","height":20,"width":20};